import { asyncAction } from 'lib/actionCreators'
import { createRoutine, promisifyRoutine } from 'redux-saga-routines'

export const managerJobDraftsList = asyncAction('manager/JOB_DRAFTS_LIST')
export const managerJobDraftData = asyncAction('manager/JOB_DRAFT')
export const markManagerJobDraftConverted = asyncAction('manager/MARK_JOB_DRAFT_CONVERTED')
export const importManagerJobDraft = createRoutine('manager/IMPORT_JOB_DRAFT')
export const importManagerJobDraftPromiseCreator = promisifyRoutine(importManagerJobDraft)
